import { useQuery } from "@tanstack/react-query";

import relationService from "@services/relation.service";
import {
  QUERY_CACHE_DEFAULT_EXPIRATION_MS,
  SUGGESTED_TAGGING_OPTIONS_QUERY_KEY,
} from "@config/query";

export function useSuggestedTags(contentType: string, objectId: string) {
  const { data, error, isLoading, fetchStatus, isPlaceholderData, refetch } = useQuery({
    enabled: Boolean(objectId && objectId.length > 0),
    queryKey: [SUGGESTED_TAGGING_OPTIONS_QUERY_KEY, objectId],
    queryFn: async () => {
      return await relationService.getSuggestedTags(contentType, objectId);
    },
    staleTime: QUERY_CACHE_DEFAULT_EXPIRATION_MS,
    retry: false,
  });

  return { data, error, isLoading, fetchStatus, isPlaceholderData, refetch };
}
